import React, { Children } from "react"
import {
  ContentfulRichTextGatsbyReference,
  renderRichText,
  RenderRichTextData,
} from "gatsby-source-contentful/rich-text"
import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types"
import { Options } from "@contentful/rich-text-react-renderer"

import {
  Bold,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Heading5,
  Heading6,
  Text,
} from "./Markdown"
import { GatsbyImage } from "gatsby-plugin-image"
import RichTextLink from "./RichTextLink/RichTextLink"
import { useLink } from "../../hooks"

type BlogBodyProps = {
  content: RenderRichTextData<ContentfulRichTextGatsbyReference>
}

export const RichText = ({ content }: BlogBodyProps) => {
      const getLink = useLink 

  const options: Options = {
    renderMark: {
      [MARKS.BOLD]: text => <Bold>{text}</Bold>,
    },
    renderNode: {
      [BLOCKS.HEADING_1]: (node, children) => <Heading1>{children}</Heading1>,
      [BLOCKS.HEADING_2]: (node, children) => <Heading2>{children}</Heading2>,
      [BLOCKS.HEADING_3]: (node, children) => <Heading3>{children}</Heading3>,
      [BLOCKS.HEADING_4]: (node, children) => <Heading4>{children}</Heading4>,
      [BLOCKS.HEADING_5]: (node, children) => <Heading5>{children}</Heading5>,
      [BLOCKS.HEADING_6]: (node, children) => <Heading6>{children}</Heading6>,
      [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
      [BLOCKS.TABLE]: (node, children) => {
        return <table>{children}</table>
      },
      [BLOCKS.TABLE_CELL]: (node, children) => {
        return <td>{children}</td>
      },
      [BLOCKS.TABLE_ROW]: (node, children) => {
        return <tr>{children}</tr>
      },
      [BLOCKS.TABLE_HEADER_CELL]: (node, children) => {
        return <th>{children}</th>
      },
    
      [INLINES.ENTRY_HYPERLINK]: (node, children) => {
        const target = node.data?.target


        if (target?.slug) {
            const href = getLink(target.slug) || `/${target.slug}`
          return (
            <a
              href={href}
              
            >
              {children}
            </a>
          )
        }

        return <>{children}</>
      },
      [BLOCKS.EMBEDDED_ASSET]: ({ data: { target } }, children) => {
        return (
          <GatsbyImage
            image={target.gatsbyImageData}
            alt={target && target.title}
            loading="lazy"
          />
        )
      },
      [BLOCKS.EMBEDDED_ENTRY]: ({ data: { target } }, children) => {
        if (!target) return <></>
        switch (target.__typename) {
          case "ContentfulComponentLink":
            return (
              <div className="rich-text-component" id="rich-text-link">
                <RichTextLink slug={target.slug} title={target.title} />
              </div>
            )

          default:
            return <></>
        }
      },
    },
  }

  return content ? (
    <div className="blog-body">{renderRichText(content, options)}</div>
  ) : null
}
